var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":_vm.$t('Incomes'),"description":_vm.$t('From here you can control the incomes')}}),_c('indexTable',{attrs:{"searchText":_vm.$t('Search for allowance'),"emptyTableText":_vm.$t('There are no incomes'),"buttonRole":_vm.$checkRole('expenses_add'),"statusSearch":true,"statusValues":[
          { title: _vm.$t('Situation'), value: '' },
          { title: _vm.$t('All'), value: '' },
          { title: _vm.$t('Draft'), value: 0 },
          { title: _vm.$t('Approved'), value: 1 }
        ],"emptyTableSubText":_vm.$t('Try adding some items to the table and try again'),"cloumns":[
          {
            column: 'code',
            title: _vm.$t('PerDiem'),
            type: 'mainLink',
            sort: true
          },
          {
            column: 'safe_id',
            title: _vm.$t('Treasury'),
            type: 'link',
            to: 'safe',
            sort: true,
            link: true
          },
          {
            column: 'date',
            title: _vm.$t('Income date'),
            type: 'text',
            sort: true
          },
          {
            column: 'income_section_id',
            title: _vm.$t('Section'),
            type: 'link',
            to: 'incomeSection',
            sort: true,
            link: false
          },
          {
            column: 'description',
            title: _vm.$t('Thats about'),
            type: 'text',
            sort: true
          },
          {
            column: 'notes',
            title: _vm.$t('Note'),
            type: 'text',
            sort: true
          },
          {
            column: 'cost',
            title: _vm.$t('Amount'),
            type: 'text',
            sort: true
          },
          {
            column: 'type',
            title: _vm.$t('Type'),
            type: 'status',
            sort: true,
            values: [
              { title: _vm.$t('Paid'), value: 0, color: 'success' },
              { title: _vm.$t('Worthy'), value: 1, color: 'dark' }
            ]
          },
          {
            column: 'user_name',
            title: _vm.$t('Responsible name'),
            type: 'text',
            sort: true
          },
          {
            column: 'status',
            title: _vm.$t('Situation'),
            type: 'status',
            sort: true,
            values: [
              { title: _vm.$t('Draft'), value: 0, color: 'dark' },
              { title: _vm.$t('Approved'), value: 1, color: 'success' }
            ]
          },
          {
            column: 'options',
            title: _vm.$t('Settings'),
            type: 'options',
            options: [
              { name: 'show' },
              { name: 'edit', role: _vm.$checkRole('expenses_edit') },
              { name: 'file' },
              { name: 'printIncome', role: true },
              { name: 'download', role: true },
              {
                name: 'delete',
                role: _vm.$checkRole('expenses_delete')
              }
            ]
          }
        ],"deleteText":{
          attention: _vm.$t('Attention'),
          areYouReallySureToDeleteTheItem: _vm.$t('Are you really sure to delete the item'),
          close: _vm.$t('Close'),
          confirm: _vm.$t('Confirm'),
          loading: _vm.$t('Loading')
        }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }